<template>
  <div class="mt-4">
    <Paging></Paging>
    <div class="clearfix"></div>
    <div class="resultlist">
        <ul class="media-list">
          <li class="media" v-for="result in results" :key="result.id">
            <result v-bind:result="result"></result>
          </li>
        </ul>
    </div>
    <Paging v-if="response && response.numFound != 0"></Paging>
  </div>

</template>

<script>
import Result from './Result'
import Paging from './Paging'

export default {
  name: 'resultlist',
  components: {
    Result,
    Paging
  },
  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    },
    results () {
      if (this.$store.state.response &&
          this.$store.state.response.response &&
          this.$store.state.response.response.docs) {
        return this.$store.state.response.response.docs
      } else {
        return '';
      }
    }
  },
  methods: {

  }
}
</script>

<style scoped>
  .media-object {
    width: 128px;
    padding:10px;
  }
  .media {
    border-top: 1px dashed lightgrey;
    padding-top: 20px;
  }
  .media-list {
    padding: 0px;
  }
</style>
